
import React from "react";

const LegendComponent = (nameToColorMapping) => {
    const styles = {
        legend: {
            display: "flex",
            flexDirection: "column"
        },
        legendItem: {
            display: "flex",
            alignItems: "center",
            marginBottom: "5px"
        },
        legendColor: {
            width: "10px",
            height: "10px",
            borderRadius: "0",
            marginRight: "5x"
        },
        legendText: {
            fontSize: "10px",
            fontFamily: "sans-serif",
            marginLeft: "5px"
        },
        label: {
            fontSize: "12px",
            fontWeight: "bold",
            fontFamily: "sans-serif",
            marginBottom: "10px"
        }
    };

    return (
        <div style={{
            position: "absolute",
            top: "10px",
            right: "80px",
            padding: "10px",
            paddingBottom: "10px",
            border: "1px solid #000",
            borderRadius: "10px",
            background: "#f0f0f0"
        }}
        >
            <div style={styles.label}>Legend</div>
            <div style={styles.legend}>
                {Object.keys(nameToColorMapping).map(category => (
                    <div key={category} style={styles.legendItem}>
                        <div
                            style={{
                                ...styles.legendColor,
                                backgroundColor: nameToColorMapping[category]
                            }}
                        />
                        <span style={styles.legendText}>{category}</span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default LegendComponent;